module.exports = __webpack_public_path__ + "images/emoji/incoming_envelope.ffe69799a1940a5448be.png";